<template>

    <v-card outlined class="ma-9 rounded-xl">
        <DialogoPreAfi ref="refModDatos" :titulo="titulo" :type="type" :componentKey="componentKey"
            :form-key="formKey" />
        <v-card-title class="mx-6 font-weight-bold primary--text">Datos personales
            <v-spacer></v-spacer>
            <v-tooltip bottom>
                <template v-slot:activator="{ on, attrs }">
                    <v-btn @click.stop="abrirDialogoEditar" v-bind="attrs" v-on="on" color="primary lighten-1" fab small
                        class="elevation-0" rounded>
                        <v-icon>mdi-pencil-outline</v-icon>
                    </v-btn>
                </template>
                <span>Editar datos personales</span>
            </v-tooltip>
        </v-card-title>
        <v-card-text class="pa-2 d-flex flex-row justify-start">
            <v-row class="py-8">
                <v-col cols="12" md="4" class="text-center">
                    <v-avatar size="200" tile style="position: relative;">
                        <v-img v-if="user.fotocarnet" :src="`data:image/png;base64,${user.fotocarnet}`"></v-img>
                        <v-img v-else src="@/assets/blank-user-profile.png"></v-img>
                    </v-avatar>
                </v-col>
                <v-col cols="12" md="4" :class="($vuetify.breakpoint.mdAndDown) ? 'text-center pa-0' : ''">
                    <div class="mb-2 font-weight-bold black--text text--darken-1 text-body-1 ">
                        {{ user.nombres }} {{ user.apellido }}
                    </div>
                    <div class="mb-2 font-weight-regular black--text text--darken-1 text-body-1">
                        DNI: {{ user.nrodoc }}
                    </div>
                    <div class="mb-2 font-weight-regular black--text text-body-1 ">
                        Fecha de nacimiento: {{ dateFormat(user.fecnacim) }}
                    </div>
                    <div class="mb-2 font-weight-regular black--text text-body-1 ">
                        Nacionalidad: {{ nacionalidad }}
                    </div>
                    <div class="mb-2 font-weight-regular black--text text-body-1 ">
                        Estado civil: {{ descEstCivil }}
                    </div>
                </v-col>
                <v-col cols="12" md="4" :class="($vuetify.breakpoint.mdAndDown) ? 'text-center pa-0' : ''">
                    <div class="mb-2 black--text text-body-1"
                        :class="($vuetify.breakpoint.mdAndDown) ? 'text-center' : ' font-weight-bold'">
                        Nº {{ afiPronombre }}: {{ user.nroafi }}
                    </div>
                    <div class="mb-2 font-weight-regular black--text text-body-1">
                        CUIL: {{ cuilFormat(user.cuil) }}
                    </div>
                    <div class="mb-2 font-weight-regular black--text text-body-1">
                        Distrito: {{ user.desdistrito }}
                    </div>
                    <div class="mb-2 font-weight-regular black--text text-body-1">
                        Estado: {{ user.estado }}
                    </div>
                    <div class="mb-2 font-weight-bold primary--text text-body-1">
                        NIVEL {{ user.nivel }}
                    </div>
                </v-col>
            </v-row>
        </v-card-text>
    </v-card>

</template>
<script>

import { mapActions, mapGetters } from 'vuex'
import DialogoPreAfi from '@/components/dialogos/DialogoPreAfi'
export default {

    name: "ListarDatosPersonales",
    components: {
        DialogoPreAfi,
    },
    data() {
        return {
            titulo: '',
            componentKey: 0,
            formKey: 0,
            type: '',
        }
    },
    mounted() {
        this.levantarCommon()
    },
    computed: {
        ...mapGetters('auth', ['isAuthenticated', 'user', 'loadSkeleton', 'esActivo', 'esJubilado', 'tienedeuda']),
        ...mapGetters('preafiliacion', ['itemNivel']),
        ...mapGetters('common', ['estadoCivil', 'nacionalidades']),

        afiPronombre() {
            switch (this.user.sexo) {
                case 'M':
                    return 'Afiliado';
                case 'F':
                    return 'Afiliada';
                default:
                    return 'Afiliadx';
            }
        },
        descEstCivil() {
            const dato = this.estadoCivil.find(e => e.id == this.user.estadocivil)
            return dato.desestadocivil
        },
        nacionalidad() {
            const dato = this.nacionalidades.find(e => e.id == this.user.nacionalidad)
            return dato.desnacionalidad
        }
    },
    methods: {
        ...mapActions('common', ['levantarCommon']),

        dateFormat(date) {
            if (!date) return null
            const [year, month, day] = date.split('-')
            return `${day}/${month}/${year}`
        },

        cuilFormat(cuil) {
            if (!cuil || cuil.length < 12) return cuil;
            const prefix = cuil.substring(0, 2);
            const dni = cuil.substring(2, cuil.length - 1);
            const suffix = cuil.substring(cuil.length - 1);
            return `${prefix}-${dni}-${suffix}`;
        },

        abrirDialogoEditar() {
            this.titulo = "Editar mi legajo"
            this.type = "modificacion"
            this.componentKey = this.componentKey++ // Incrementa la clave para forzar la recreación del componente
            this.formKey = this.componentKey++ // Incrementa la clave para forzar la recreación del componente
            this.$refs.refModDatos.abrirDialogo()
        }
    }
}

</script>